import React, { useEffect } from 'react'
import { motion } from 'framer-motion';
import blog from '../assets/blog.svg';
import blog01 from "../assets/blogimages/blog01.jpg";
import blog02 from "../assets/blogimages/blog02.jpg";
import blog03 from "../assets/blogimages/blog03.jpg";
import blog04 from "../assets/blogimages/blog04.jpg";
import blog05 from "../assets/blogimages/blog05.jpg";
import blog06 from "../assets/blogimages/blog06.jpg";
import blog07 from "../assets/blogimages/blog07.jpg";
import blog08 from "../assets/blogimages/blog08.jpg";
import blog09 from "../assets/blogimages/blog09.jpg";
import { Link } from 'react-router-dom';
import BackToTop from './BackToTop';

export default function Blog() {
  document.title = "Blogs | Krupali Desai";
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);
  const data = {
    blogs: [
      {
        id: "blog01",
        title: "Embarking on the Path to Mastery: Insights and Pointers for Full-Stack Web Development",
        image: blog01,
        description: "🌟✨👩‍💻 The journey of becoming a full-stack web developer is an exciting and fulfilling adventure, filled with learning opportunities and growth. In this comprehensive guide, we will provide you with valuable tips and insights to help you navigate this journey..."
      },
      {
        id: "blog02",
        title: "Unleashing the Potential of JavaScript: Exploring Contemporary Frameworks and Libraries",
        image: blog02,
        description: "🌟🔥💻 JavaScript is a versatile programming language that has revolutionized web development. In this article, we will explore the power of JavaScript and delve into modern frameworks and libraries that have transformed the..."
      }, 
      {
        id: "blog03",
        title: "The Art of Back-End Development: Constructing Resilient and Expandable Solutions",
        image: blog03,
        description: "🌐💪🔍 Building robust and scalable back-end solutions is the backbone of modern web development. In this article, we will demystify the world of back-end development, exploring the key concepts, technologies, and best practices that empower..."
      },
      {
        id: "blog04",
        title: "Excel in Front-End Development: Key Competencies and Optimal Approaches",
        image: blog04,
        description: "🌟🎨🖥️Front-end development is an exciting and ever-evolving field that bridges the gap between design and technology. As a front-end developer, you have the power to create stunning user interfaces and deliver immersive..."
      },

      {
        id: "blog05",
        title: "Unveiling the API Landscape: A Definitive Handbook for Web Developers",
        image: blog05,
        description: "🌐🔍💻 APIs (Application Programming Interfaces) play a pivotal role in modern web development, enabling seamless communication and integration between different software applications. In this comprehensive guide, we..."
      },

      {
        id: "blog06",
        title: "Ensuring Web Application Security: Optimal Strategies for Web Developers",
        image: blog06,
        description: "🔒💻🔍Securing web applications is of paramount importance in today's digital landscape. As a web developer, it is crucial to understand the best practices and techniques for protecting your applications and users from potential threats. In this comprehensive..."
      },
      {
        id: "blog07",
        title: "Enhancing Efficiency: Accelerating Your Web Projects through Performance Optimization",
        image: blog07,
        description: "⚡💻🚀 In today's fast-paced digital world, website performance plays a crucial role in user experience and business success. Slow-loading websites not only frustrate users but also have a negative impact on conversion rates and search engine..."
      },
      {
        id: "blog08",
        title: "Creating Dynamic User Experiences: Designing Engaging Interfaces for Diverse Devices",
        image: blog08,
        description: "📱💻🖥️ In today's digital landscape, users access websites and applications from a wide range of devices, including smartphones, tablets, laptops, and desktop computers. To provide a seamless and engaging user experience..."
      },
      {
        id: "blog09",
        title: "Essential Database Principles for Web Developers: Transitioning from SQL to NoSQL",
        image: blog09,
        description: "🗃️📚💻 Databases are an essential component of web development, storing and organizing data to power dynamic applications. In this comprehensive guide, we will explore the fundamentals of databases, from traditional SQL..."
      }
    ],
  };
  const animations = {
    head: {
      initial: {
        y: '40%',
        opacity: 0
      },
      whileInView: {
        y: '0',
        opacity: 1
      },
      transition: {
        duration: 0.65,
      }
    },
  }

  return (
    <div className='blogsection'>
      <motion.div {...animations.head} className="head">
        <h1>Blogs</h1>
        <img src={blog} alt="" />
      </motion.div>

      <div className="blogs">
        {data.blogs.map((blog, index) => (
          <motion.div {...animations.head} className="blogcard">
            <Link to={`/blogs/${blog.id}`}>
              <img src={blog.image} alt="" />
              <h3>{blog.title}</h3>
              <p>{blog.description}</p>
            </Link>
          </motion.div>
        ))
        }
      </div>

      <BackToTop />
    </div>
  )
}
